module.exports = __webpack_public_path__ + "static/img/10.2bbe963d.jpg";